import { QUERY_KEYS } from '@/config/constant'
import TGASDK from '@/config/TGASDK'
import { Wallet } from '@kulee/tga-sdk'
import type { ChargeCommodity, CurrencyCode } from '@kulee/tga-sdk/types/types/wallet'
import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import useRuntime from '../useRuntime'

const useChargeCommodityList = (currencyCode: CurrencyCode, paymentCurrencyCode?: CurrencyCode, price?: number) => {
  const { lang, channel } = useRuntime()

  useEffect(() => {
    TGASDK.addModule(Wallet)
  }, [])

  return useQuery({
    queryKey: [QUERY_KEYS.WALLET_CHARGE_COMMODITY, lang, channel, currencyCode, paymentCurrencyCode, price],
    queryFn: async (): Promise<ChargeCommodity[]> => {
      const { data } = await TGASDK.module.Wallet.service.getChargeCommodityList({
        currencyCode,
        paymentCurrencyCode,
        price
      })

      return data
    }
  })
}

export default useChargeCommodityList
